import * as propertyTypes from "../property_types.js"

export class UiStatistic extends propertyTypes.AppBaseComponentProps {

    private statisticIdMetadata = new propertyTypes.StatisticProperty("statisticId", "Statistic id");
    public statisticId: string;

    private parametersMetadata = new propertyTypes.DictionaryProperty("parameters", "Parameters");
    public parameters: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.statisticIdMetadata, this.parametersMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}